import BaseModel from '../core/BaseModel'
export default class CustomerModel extends BaseModel {

    constructor() {
        super({ 
                name: "customer",
                tableName: 'core_customer_profile', 
                label: "Quản lý khách hàng"
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Tên khách hàng',
                sortable: true,
                filter: { type: 'input',  match: 'custom'}
            },
            phoneNumber: { 
                name: 'phoneNumber', 
                type: "String", 
                label: 'Số điện thoại', 
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                    var phone = (data.phone_number != undefined && data.phone_number != '') ? data.phone_number : '';
                    if (phone != '') data.phoneNumber = phone.replace('+84', '0') ;
                }
            },
            customer_type: { 
                name: 'customer_type', 
                type: "Selection", 
                label: 'Nhóm khách hàng', 
                sortable: true,
                dataType: 'Label',  class: 'center',
                options: [{ value: 1, label: 'Cá nhân'}, { value: 2, label: 'Doanh nghiệp'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' }
            },
            list_activation: {
                name: 'list_activation', type: 'String', label: 'Danh sách kích hoạt', class: 'center', width: 8,
                callback: true,
                computed: (data) => {
                    data.list_activation = '<abbr class="external-link black-color bold"><span class="pi pi-external-link"></span></abbr>';
                }
            },
            list_warranty: {
                name: 'list_warranty', type: 'String', label: 'Danh sách bảo hành', class: 'center', width: 8,
                callback: true,
                computed: (data) => {
                    data.list_warranty = '<abbr class="external-link black-color bold"><span class="pi pi-external-link"></span></abbr>';
                }
            },
            history: {
                name: 'history', type: 'String', label: 'Lịch sử', class: 'center', width: 8,
                callback: true,
                computed: (data) => {
                    data.history = '<abbr class="external-link black-color bold"><span class="material-icons"> restore </span></abbr>';
                }
            },
            user_id: {
                refs: 'user_id phone_number birthday email address province { id name } district { id name } ward { id name }',
                display: false
            },
        },)
    }

}